module.exports = __webpack_public_path__ + "static/img/weibo_icon.e047b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weibo_icon.png
// module id = I1Tv
// module chunks = 1